export { EAuthRoute, EUsersRoute, EUserRolesRoute } from '../userService/definitions'
export type { TRole, TRoles, TUsers, TUsersWithRoles } from '../userService/definitions'

export type TRoute = (
  '/' |
  '/menu' |
  '/raktar-feladatok' |
  '/bejovo-termekek' |
  '/webshopok' |
  '/termekmegosztas' |
  '/konkurencia' |
  '/webscraper' |
  '/langedit' |
  '/gephaz/jogosultsagok' |
  '/gephaz/felhasznalok' |
  '/arajanlatok' |
  '/hibas-termekek' |
  '/kilepes' |
  '/monitor' |
  '/megrendelesek' |
  '/bejovo-arajanlatok' |
  '/activator' |
  '/raktar-koltesek' |
  '/szabalyzatok' |
  '/ugyesedni-admin' |
  '/blog'
)

/** Olyan válasz a szervertől, ami biztosítja, hogy lapozósan megjeleníthető az adat. */
export interface IPaginationResponse<T> {
  readonly total: number
  readonly actPage: number
  readonly itemsPerPage: number
  readonly items: T
}

/** Iframe ezt küldi, ha azt szeretné, hogy kilépjenek belőle. */
export const CORP_MODULE_EXIT_REQUEST = 'Corp:Module:ExitRequest'
